import { compose } from "redux";
import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IAction } from "../../../../models/Action";
import { immutableSet } from "../../../../utils/immutable";
import { actionTypes } from "./actions";
import { STATE_IDENTIFIER } from "./constants";
import emptyState from "./emptyState";

const { CONFIG_LIST, LOADER_IDENTIFIER, CALL_STATE } = STATE_IDENTIFIER;

const ACTION_HANDLERS = {
  [actionTypes.ADMIN_UIGP_CONFIG_REQUEST]: (state: any, action: any) =>
    immutableSet([LOADER_IDENTIFIER], true, state),
  [actionTypes.ADMIN_UIGP_CONFIG_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([CONFIG_LIST], action.payload)
    )(state);
  },
  [actionTypes.ADMIN_UIGP_CONFIG_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => {
    return compose(
      immutableSet([LOADER_IDENTIFIER], false),
      immutableSet([CONFIG_LIST], [])
    )(state);
  },
  [actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST]: (state: any, action: any) =>
    immutableSet([CALL_STATE], IResponseState.PENDING, state),
  [actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST_SUCCESS]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.SUCCESS, state),
  [actionTypes.ADMIN_UIGP_CONFIG_UPDATE_REQUEST_FAILURE]: (
    state: any,
    action: any
  ) => immutableSet([CALL_STATE], IResponseState.ERROR, state),
};

export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  if (
    action &&
    action.type === "@@router/LOCATION_CHANGE" &&
    (action.payload.location.pathname === "/welcome" ||
      action.payload.location.pathname === "/admin")
  ) {
    return emptyState;
  }
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
